{
  "registers": {
    "intro": "Every register (till) of the shop: its tablets, printer and drawer. A new tablet is connected with a one-time code.",
    "new": "Add a register",
    "tabs": "Registers or staff PINs",
    "tab_registers": "Registers",
    "tab_pins": "Staff PINs",
    "load_failed": "The registers could not be loaded.",
    "empty": "No register yet",
    "empty_body": "Add the first register, then connect the tablet with its code.",
    "pair": "Connect a tablet",
    "edit": "Change",
    "shifts": "Its shifts",
    "status_active": "In use",
    "status_disabled": "Switched off",
    "edc_note": "Card terminals and their fees are set in Payments.",
    "edc_link": "Open Payments"
  },
  "card": {
    "location": "Shop",
    "shift": "Till",
    "open_by": "Open by {{name}}",
    "closed": "Closed",
    "printer": "Receipt printer",
    "no_printer": "No printer",
    "drawer": "Cash drawer",
    "drawer_yes": "Yes",
    "drawer_no": "No"
  },
  "tablets": {
    "none": "No tablet connected yet.",
    "count_one": "{{count}} tablet",
    "count_other": "{{count}} tablets",
    "online": "online",
    "last_seen": "last seen",
    "never": "not used yet",
    "revoke": "Disconnect",
    "revoke_title": "Disconnect this tablet?",
    "revoke_consequence": "The tablet stops working at once; everyone signed in on it is signed out. Connect it again with a new code.",
    "revoked": "Tablet disconnected."
  },
  "form": {
    "new_title": "Add a register",
    "edit_title": "Change {{name}}",
    "name": "Name",
    "name_hint": "What staff call it, e.g. \"Counter 1\".",
    "code": "Short code",
    "code_hint": "Printed on receipts, e.g. REG-1.",
    "location": "Shop",
    "drawer": "Cash drawer",
    "drawer_hint": "Opens when a cash sale is finished.",
    "printer": "Receipt printer",
    "ip": "Printer address (IP)",
    "ip_hint": "Printed on the printer's self-test slip, e.g. 192.168.1.50.",
    "bt": "Bluetooth name",
    "bt_hint": "The printer's name in the tablet's Bluetooth list.",
    "paper": "Paper width",
    "active": "In use",
    "required": "Fill this in.",
    "create": "Save and connect a tablet",
    "save": "Save",
    "created": "Register added.",
    "saved": "Saved."
  },
  "printer": {
    "network": "LAN / Wi-Fi",
    "network_help": "The printer is on the shop's network — type the address it prints on its self-test slip.",
    "bluetooth": "Bluetooth",
    "bluetooth_help": "Pair the printer with the tablet first, then type its name here.",
    "webusb": "USB cable",
    "webusb_help": "The printer is plugged into the tablet with a cable; the tablet asks once for permission.",
    "sunmi": "Built-in (Sunmi)",
    "sunmi_help": "The printer is part of the Sunmi terminal — nothing to type.",
    "none": "No printer",
    "none_help": "Receipts are sent by e-mail only."
  },
  "pairing": {
    "title": "Connect a tablet to {{name}}",
    "intro": "Type this code on the tablet within the time shown. The code works once.",
    "making": "Making the code…",
    "code_label": "Code {{code}}",
    "left": "Still {{time}}",
    "expired": "This code has ended.",
    "again": "New code",
    "qr": "QR code for the tablet",
    "step1": "Open the register app on the tablet.",
    "step2": "The tablet shows “Register this tablet”. The code below connects it to {{name}} ({{code}}) by itself — nothing to choose.",
    "step3": "Type this code (or scan the QR).",
    "once": "The code is shown only here and is forgotten when you close this.",
    "close": "Close"
  },
  "pin": {
    "intro": "The PIN staff use at the register. Resetting asks first and is recorded.",
    "has": "Has a PIN",
    "none": "No PIN",
    "reset": "Reset PIN",
    "load_failed": "The staff list could not be loaded.",
    "title": "Reset the PIN of {{name}}?",
    "consequence": "The old PIN stops working at once.",
    "how": "New PIN",
    "temporary": "A temporary PIN",
    "temporary_hint": "Shown once here — tell it to them; they choose their own at the register.",
    "clear": "No PIN — they choose one at the register",
    "clear_hint": "They sign in with their password once and set a PIN.",
    "cancel": "Keep the PIN",
    "confirm": "Reset PIN",
    "shown_once": "Tell this PIN to the staff member now. It will not be shown again.",
    "cleared": "The PIN was removed — they set a new one at the register.",
    "done": "Done"
  },
  "receipt": {
    "header_title": "Top of the receipt",
    "shop_name": "Shop name",
    "tnumber": "登録番号 (invoice number)",
    "kobutsu": "古物商許可番号",
    "address": "Address · phone",
    "not_set": "Not set yet",
    "placeholder": "example number — not real yet",
    "change_in_tax": "Change in Tax settings",
    "change_in_store": "Change in Store settings",
    "texts_note": "The thank-you line and the return rules come from the shop system setup; changing them here comes later.",
    "preview_label": "Receipt preview",
    "preview_caption": "80 mm receipt with the settings on this page (sample card).",
    "no_name": "(shop name)",
    "consigned_note": "Consigned cards are printed here, apart from the shop's own.",
    "qr_line": "Scan for the digital receipt"
  },
  "rules": {
    "intro": "How the registers work: offline, discounts, buy-ins, 取り置き, labels. Each rule says what it does.",
    "tabs": "Rules or receipt",
    "tab_rules": "Rules",
    "tab_receipt": "Receipt",
    "load_failed": "The register rules could not be loaded.",
    "groups": {
      "offline": "When the internet is down",
      "money": "Discounts and the cash drawer",
      "buylist": "Buy-ins (買取)",
      "holds": "Layaways (取り置き)",
      "labels": "Labels and the 古物台帳",
      "tax_free": "Tax-free (免税)",
      "receipt": "Receipt"
    },
    "tax_free_on": "The shop's tax-free licence is set.",
    "tax_free_needs_licence": "Set the 輸出物品販売場 licence first.",
    "tax_free_link": "Open Tax settings",
    "default": "Back to the shop default ({{value}})",
    "save": "Save the rules",
    "saved": "Rules saved — the registers use them within a minute.",
    "changed_one": "{{count}} change",
    "changed_other": "{{count}} changes",
    "nothing": "No changes",
    "read_only": "Only the owner can change these rules.",
    "problems": {
      "number": "Type a whole number.",
      "min": "At least {{min}}.",
      "max": "At most {{max}}.",
      "choice": "Choose one.",
      "text": "Fill this in."
    }
  },
  "units": {
    "minutes": "minutes",
    "percent": "%",
    "days": "days",
    "count": "entries",
    "yen": "¥"
  },
  "choices": {
    "defaultDocumentType": {
      "kani_invoice": "Simplified invoice (適格簡易請求書)",
      "tekikaku_invoice": "Full invoice (適格請求書)"
    },
    "defaultReceiptMode": {
      "print": "Paper",
      "email": "E-mail",
      "print_and_email": "Paper and e-mail",
      "ask": "Ask every time"
    },
    "labelSizeDefault": {
      "40x30": "40 × 30 mm",
      "58x40": "58 × 40 mm"
    }
  },
  "shifts": {
    "title": "Shift",
    "intro": "Every shift of the registers with its sales, 過不足 and Z-report. Shifts are opened and closed at the register.",
    "cash_intro": "The cash of each drawer: change at the start, what should be there, what was counted and the difference.",
    "period": "Days (Japan time)",
    "register": "Register",
    "only_difference": "Only with a difference",
    "opened": "Opened",
    "closed": "Closed",
    "still_open": "Still open",
    "float": "Change at the start",
    "expected": "Should be",
    "counted": "Counted",
    "variance": "過不足",
    "sales_count": "Sales",
    "net": "Sales after returns",
    "fee": "Card fees",
    "z_report": "Z-report",
    "z_ready": "Ready",
    "z_none": "Not closed yet",
    "z_pending": "Being made",
    "z_issued": "Ready",
    "z_unsupported": "Not available yet",
    "drawer": "Cash drawer",
    "approved_by": "The manager approved the difference: {{name}}",
    "by_tender": "By way of payment",
    "tender": "Payment",
    "count": "Count",
    "sales": "Sales",
    "refunds": "Refunds",
    "tax": "消費税",
    "discount": "Discounts",
    "pickups": "Web orders picked up",
    "review": "To check",
    "card_fees": "Card terminal fees",
    "status_open": "open",
    "status_closed": "closed",
    "cash_moves_note": "Each 入金 / 出金 with its reason is on the Z-report PDF; a separate list in the back office comes later."
  },
  "tenders": {
    "cash": "Cash",
    "edc_external": "Card terminal",
    "store_credit": "Store credit",
    "stripe_terminal": "Card (Stripe)",
    "stripe_payment_link": "QR payment (Stripe)",
    "pay_in_store": "Pay at the shop",
    "bank_transfer_manual": "Bank transfer"
  },
  "buylist": {
    "intro": "Cards the shop bought at the registers (買取) — from the 古物台帳. Buying happens at the register.",
    "paid": "Paid",
    "seller": "Seller",
    "purchase": "Purchase",
    "no_access": "Only staff who may open the 古物台帳 see the purchases.",
    "note": "Payment method and the purchase slip are on the register; the full record is in the 古物台帳.",
    "open_ledger": "Open the 古物台帳"
  }
}
